import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  list: {
    ...theme.globalClasses.list,
    color: theme.palette.text.primary,
    padding: 0,
    margin: 0,
  },
  frame: {
    ...theme.globalClasses.frame,
    padding: '16px',
    width: '100%',
  },
}));

/**
 * The Patient Nutrient Profile Box displays the data:
 * - title (string)
 * - data (dynamic data)
 *
 * If there is no data, the box will not be displayed.
 *
 * @param {object} data - The nutrient data to display
 * @param {number|string} maxWidth - Maximum width of the box, defaults to 100%
 * @param {string} variant - The variant of the box, defaults to 'current'; alternative is 'goal'
 * @returns
 */
const PatientNutrientProfileBox = ({ data, maxWidth = '100%', variant = 'current' }) => {
  const classes = useStyles();

  if (!data || data.length === 0) {
    return <></>;
  }

  return (
    <Box sx={{ width: '100%', maxWidth: `${maxWidth}` }}>
      <Box
        className={classes.frame}
        sx={{ overflow: 'hidden' }}
      >
        <Box sx={{ width: '100%' }}>
          {/* Title and Calorie Section */}
          <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
            <Typography variant={'h3'}>{variant === 'current' ? 'Current' : 'Goal'} Nutrient Profile</Typography>
          </Box>

          {/* Vertical nutrient data */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {data.map((nutrient, index) => (
              <Box
                key={nutrient.key}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    mr: 1,
                    maxWidth: '70%',
                    alignSelf: 'center',
                  }}
                >
                  {nutrient.name}
                </Typography>
                <Chip
                  label={nutrient.value}
                  sx={{
                    flexShrink: 0,
                    '& .MuiChip-label': {
                      fontWeight: index === 0 ? 600 : 400,
                    },
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PatientNutrientProfileBox;
